import { render, staticRenderFns } from "./PrestationsEpilations.vue?vue&type=template&id=40971594&"
import script from "./PrestationsEpilations.vue?vue&type=script&lang=js&"
export * from "./PrestationsEpilations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports